import React from "react";
import Scrollspy from 'react-scrollspy';
import WindowBrowser from "../components/browser-window";

const Implementation = () => {
  return (
    <div className="simple_page">
      <div className="mainIntro">
        <h1>Implementation</h1>
        <h3>Spot the fake. Safeguard the cure.</h3>
      </div>

      <div className="max-w-2xl mx-auto mt-8">
        <div className="w-full h-11 rounded-t-lg bg-gray-900 flex justify-start items-center space-x-1.5 px-3">
          <span className="w-3 h-3 rounded-full bg-red-400"></span>
          <span className="w-3 h-3 rounded-full bg-yellow-400"></span>
          <span className="w-3 h-3 rounded-full bg-green-400"></span>
        </div>
        <div className="bg-gray-700 border-t-0 w-full h-96"></div>
      </div>

      <section className="divider">
        <div className="fixed_sidebar">
          <div className="sidebar">
            <div className="main_sidebar">
              Implementation
            </div>

            <Scrollspy
              offset={-140}
              className="scrollspy"
              items={['Application', 'Ethical_Concerns_in_Deployment', 'Regulatory_and_Compliance']}
              currentClassName="active">
              <li><a href="#Application">Real-World Application</a></li>
              <li><a href="#Ethical_Concerns_in_Deployment">Ethical Concerns in Deployment</a></li>
              <li><a href="#Regulatory_and_Compliance">Regulatory and Compliance</a></li>
             
            </Scrollspy>
            <img
              src="https://static.igem.wiki/teams/5334/wiki-images/updated-mascot/mascot-running-4.webp"
              alt="Mascot is running"
            
            />

          </div>
        </div>
        <div className="main_lab_style">
          <WindowBrowser  description={
            <div>

           <h1>
            Introduction
           </h1>
           <p>
           In recent decades, despite countless global challenges, humans have reached a level of healthcare never seen in human history. However, with recent advancements, some health challenges remain, including the prevalence of counterfeit medication, the high cost of drugs, unequal access to treatment and sustainability. Bevacizumab, which is responsible for treating numerous types of cancer, such as colon, lung, ovarian and other cancers, was no exception. To help with the challenges, we chose the project that focuses on developing a Lateral Flow Assay (LFA) to tackle one of the issues: counterfeit drugs that pose significant risks, particularly in low-income regions such as Africa and Southeast Asia. This part will elaborate on the practical steps for real-world implementation and address critical ethical issues in ensuring the safety and accessibility of the LFA. 
           </p>


           <section id="Application">
            <br />
            <h1>
            Real-World Application
            </h1>
            <p>
            To ensure that our tools work to the best of their ability, we included simple and easy-to-follow instructions so that even the patients can perform the LFA test reliably and effectively. For healthcare workers, remote training/guides and how-to videos will be provided to better suit their role; this ensures that most people can perform this test using our LFA to detect Bevacizumab.
            </p>
            <p>
            A thorough and balanced distribution of our LFA might be complicated as regional infrastructure development varies, which can harm our implementation. Hence, we are committed to promoting local partnerships with local governments and organizations to help distribute this kit to the deepest and most remote clinics or healthcare facilities. This can also be expanded to cooperation with NGOs and distributors that have their established route to help smoothen the deployment of LFA kits, especially in warzone or remote areas, it will ensure that the product reaches the most vulnerable populations.
            </p>

            <img src="https://static.igem.wiki/teams/5334/wiki-images/implementation/untitled-artwork-16.png"></img>
           </section>


{/* 

              <section id="Distribution_Channel">
                <h1>1. Distribution Channel</h1>
                <p>
                  Our distribution strategy aims to reach a wide range of stakeholders to ensure broad accessibility of the Bevacizumab detection test:
                </p>
                <ul>
                  <li><strong>Pharmaceutical companies (40%):</strong> We will partner with major pharmaceutical firms that manufacture and distribute Bevacizumab (Avastin) to integrate our detection solution into their quality control and supply chain processes.</li>
                  <li><strong>Non-Governmental Organizations (15%):</strong> We will collaborate with NGOs focused on global healthcare initiatives to provide our detection kits to underserved regions and communities.</li>
                  <li><strong>Hospitals and local pharmacies (35%):</strong> We will establish direct sales channels with hospitals and local pharmacies to enable them to easily verify the authenticity of Bevacizumab products they receive and dispense.</li>
                  <li><strong>Regulatory Organizations (10%):</strong> We will work closely with relevant regulatory bodies, such as the FDA and NMPA, to have our detection solution approved and integrated into their drug quality assurance programs.</li>
                </ul>
              </section>

              <section id="Pricing_Strategy">
                <h1>2. Pricing Strategy</h1>
                <p>
                  To ensure widespread accessibility, we have developed a tiered pricing strategy:
                </p>
                <ul>
                  <li><strong>100~500 units:</strong> $225 per 100 units</li>
                  <li><strong>500 units:</strong> $200 per 100 units</li>
                </ul>
                <p>
                  This pricing structure aims to balance affordability for smaller-scale users, such as local pharmacies, while also providing volume discounts for larger-volume customers, such as pharmaceutical companies and NGOs.
                </p>
              </section>

              <section id="Product_Development_Plan">
                <h1>3. Product Development Plan</h1>
                <p>
                  Our product development plan is structured across four quarters, focusing on key milestones:
                </p>
                <ol>
                  <li><strong>Q2/2024:</strong> Conduct initial research, design the assay, and identify the specific aptamer sequence.</li>
                  <li><strong>Q3/2024:</strong> Conduct proof-of-concept experiments to test the technical feasibility and validate the aptamer's sensitivity and specificity. Develop the minimum viable product (MVP).</li>
                  <li><strong>Q4/2024:</strong> Integrate the aptamer into the lateral flow assay, create a prototype, and test the product's stability and performance against competitors.</li>
                  <li><strong>Q1/2025:</strong> Optimize the strip parameters based on feedback, set up an assembly line, and commence large-scale production.</li>
                </ol>
              </section>

              <section id="Business_Development_Planning">
                <h1>4. Business Development Planning</h1>
                <p>
                  Our business development strategy spans four quarters, focusing on market research, partnership development, and regulatory approvals:
                </p>
                <ol>
                  <li><strong>Q2/2024:</strong> Perform market research, analyze pain points, and conduct interviews with hospitals and pharmaceutical companies. Study potential competitors.</li>
                  <li><strong>Q3/2024:</strong> Attend academic conferences to seek comments and advice, and explore collaborations and partnerships with hospitals and pharmaceutical companies.</li>
                  <li><strong>Q4/2024:</strong> Deliver sample products to hospitals and pharmaceutical companies for feedback, attend industry conferences and exhibitions for promotion, and apply for production license and registration certificate from the NMPA.</li>
                  <li><strong>Q1/2025:</strong> Apply for De Novo Classification and 510(k) Premarket Notification from the FDA, explore opportunities for geographical expansion or product line extensions, and plan and execute a launch event.</li>
                </ol>
              </section>

              <section id="Finance_Planning">
                <h1>5. Finance Planning</h1>
                <p>
                  Our financial planning involves self-funding, revenue projections, and strategic fundraising:
                </p>
                <ol>
                  <li><strong>Q2/2024:</strong> Determine the overall investment required and self-fund $10,000 to start R&D.</li>
                  <li><strong>Q3/2024:</strong> Prepare revenue projections and budget for future marketing activities and R&D.</li>
                  <li><strong>Q4/2024:</strong> Establish financial management systems and apply for the HK Tech 300 Seed Fund ($13,000).</li>
                  <li><strong>Q1/2025:</strong> Apply for the HKSTP Incu-Bio Programme ($770,000) and start small-scale sales to acquire revenue.</li>
                </ol>
              </section> */}

              <section id="Ethical_Concerns_in_Deployment">
                <br />
                <h1>Ethical Concerns in Deployment</h1>
                <p>
                Ethical issues in our kit’s deployment are our utmost concern, to mitigate this, we are committed to performing rigorous testing protocols, complying with regulatory requirements and improving quality control processes to ensure the kit’s accuracy and minimise false positives or negatives. This also includes post-market surveys that monitor its performance in real-life applications.
                </p>
                <p>
                To ensure fair access to all, we will perform a tiered pricing structure which, depending on the socio-economic situation of a country and its policies on drug prices, will have different tags. However, we are committed to cooperating with NGOs and governmental organisations to make the LFA affordable in a low-income setting, this can be achieved through subsidies, partnerships, and donations. It is possible to create a local manufacturing or assembly in the region to lower the cost even further or, if necessary, for free.
                </p>
                <img src="https://static.igem.wiki/teams/5334/wiki-images/implementation/cityuhk-igem-bevatech.svg"></img>
              </section>


              <section id="Regulatory_and_Compliance">
                <br />
                <br />
                <h1>
                  Regulatory and Compliance
                </h1>
                <p>
                Our kits will comply with international standards, including ISO13485, ISO 9001, Good Manufacturing Practice (GMP), and World Health Organization (WHO) Prequalification, ensuring our product is safe and regarded as the highest quality possible globally.
                </p>
                <p>
                As we are committed to ensuring the long-term success and effectiveness of the LFA, this requires a detailed post-deployment support plan that will include the following steps:
                </p>

                <ol>
                  <li><strong>Continuous Testing and Validation:</strong> Randomised regular testing of our kits in different regions and conditions will ensure we have the real-life data of LFA in a significant way, this means we can maintain its accuracy and reliability and can include environmental tests and performance reviews.
                  </li>
                  <li><strong>User Feedback Collection:</strong> Workers and patients using the kits will have a way to provide regular feedback that will be compiled and allow us to assess the kits thoroughly, for example, the effectiveness, potential reliability issues and ease of use.
                  </li>
                  <li><strong>Continuous Improvement:</strong> We will update the LFA design and performance as necessary based on feedback and ongoing validation. This could include minor reagent adjustments, user instructions, or updated product design to improve performance in various settings and conditions.</li>
                  <li><strong>Monitoring for Regulatory Updates:</strong> To keep up with the constantly evolving regulatory or compliance guidelines in different regions, we will monitor these standards to ensure compliance. This approach ensures that our LFA remains within the safety and efficacy requirements. 
                  </li>
                </ol>

                <br />
                <br />

              </section>
            </div>
          } />
        </div>
      </section>
    </div>
  );
}

export default Implementation;
